import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'

import { Observable } from 'rxjs'

import { environment } from '../../../environments/environment'

import { Stock } from '../models/stock'

const stockUrl = '/stocks'

@Injectable()
export class StockService {
    constructor(
        private http: HttpClient
    ) {}

    getStock(products: string[]): Observable<Stock[]> {
        let params = new HttpParams()
            .append('productcodes', products.join('|'))

        return this.http.get<Stock[]>(
            environment.baseApiUrl + stockUrl,
            { params }
        )
    }
}